var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardQuantity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.625 20L15 .833 29.375 20 15 39.167.625 20z",
    fill: "#fff",
    stroke: "#000"
  })));
}
export default SvgCardQuantity;